( ( $ ) => {
	$( document ).on( 'ready', () => {
		if ( !( 'gtag' in window ) || !( 'dataLayer' in window ) ) {
			return;
		}

		window.dataLayer.forEach( item => {
			if ( !( 'ecommerce' in item )
				|| ('ecommerce' in item && item.ecommerce === null )
				|| !( 'purchase' in item.ecommerce ) ) {
				return;
			}

			window.gtag( 'event', 'purchase', {
				transaction_id: item.ecommerce.purchase.actionField.id,
				value: item.ecommerce.purchase.actionField.revenue,
				tax: item.ecommerce.purchase.actionField.tax,
				shipping: item.ecommerce.purchase.actionField.shipping,
				currency: item.ecommerce.currencyCode,
				coupon: item.ecommerce.purchase.actionField.coupon,
				items: item.ecommerce.purchase.products.map( product => {
					return [
						{
							item_id: product.id,
							item_name: product.name,
							affiliation: product.brand,
							item_brand: product.brand,
							item_category: product.category,
							item_variant: product.variant,
							price: product.price,
							quantity: product.quantity,
						}]
				} ),
			} );
		} );
	} );
} )( jQuery );


// WEBPACK FOOTER //
// ./scripts/tracking/gtag.js